import { createI18n } from 'vue-i18n'
import nl from './locales/nl.json'
import en from './locales/en.json'

// Locale-aware number formatting. Money in the UI goes through `$n(value,
// 'currency')` so grouping/decimal separators follow nl-NL ("€ 19,99") vs
// en ("€19.99") instead of a hardcoded "€" prefix. Exported so tests build
// their i18n with the same formats.
// `integer` groups whole numbers per locale (nl "2.348" vs en "2,348") for the
// KPI counters; `currency` formats money. Both go through `$n(value, <fmt>)`.
export const numberFormats = {
  nl: {
    currency: { style: 'currency', currency: 'EUR' },
    integer: { maximumFractionDigits: 0 },
  },
  en: {
    currency: { style: 'currency', currency: 'EUR' },
    integer: { maximumFractionDigits: 0 },
  },
} as const

export const i18n = createI18n({
  legacy: false,
  locale: 'nl',
  fallbackLocale: 'en',
  messages: { nl, en },
  numberFormats,
})
